<ng-container *ngIf="loaded">
  <h2 class="text-tertiary d-flex justify-content-between uppercase">
    <span mat-dialog-title>{{
      multilingualService.langMap?.LABEL_MORE_SETTINGS_ACCOUNT_PROFILE
    }}</span>
    <button
      *ngIf="data || showError"
      mat-dialog-close
      class="close"
      mat-icon-button
      [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
    >
      <mat-icon class="icon-cross"></mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="form-content mt-2 form-width" *ngIf="!showError">
      <p class="title-10">
        {{ multilingualService.langMap?.UPDATE_PROFILE_INFO_MSG }}
      </p>
      <form [formGroup]="userForm">
        <div class="mb-2">
          <div class="form-group mb-2">
            <label for="email_input"
              >{{ multilingualService.langMap?.LABEL_REGISTRATION_FORM_EMAIL }}
              <span class="text-primary text-w-600">*</span></label
            >
            <input
              id="email_input"
              formControlName="email"
              type="text"
              class="form-control"
              (keyup)="checkEmailUpdateEvent($event)"
            />
            <span
              role="alert"
              *ngIf="
                this.userForm.get('email')?.errors?.required &&
                this.userForm.get('email')?.touched
              "
              class="text-danger"
              >{{ multilingualService.langMap?.MESSAGE_ENTER_EMAIL }}</span
            >
            <span
              role="alert"
              *ngIf="
                this.userForm.get('email')?.errors?.pattern &&
                this.userForm.get('email')?.touched
              "
              class="text-danger"
              >{{
                multilingualService.langMap?.MESSAGE_ENTER_VALID_EMAIL
              }}</span
            >
          </div>
          <ng-container *ngIf="emailUpdate">
            <div class="form-group mb-2" *ngIf="resendOtp">
              <label for="otp_input"
                >{{
                  multilingualService.langMap
                    ?.LABEL_UPDATE_PROFILE_FORM_VERIFICATION_CODE
                }}<span class="text-primary text-w-600">*</span></label
              >
              <input
                id="otp_input"
                [(ngModel)]="otpValue"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                class="form-control"
                (keypress)="checkIfSpace($event)"
                [disabled]="!resendOtp"
                maxlength="6"
              />
            </div>
            <div class="button-group center" *ngIf="!otpVerified">
              <button
                mat-raised-button
                class="primary-button uppercase"
                (click)="sendVerificationCode(true)"
                [disabled]="resendOtp || this.userForm.get('email')?.invalid"
                *ngIf="!resendOtp"
              >
                {{
                  multilingualService.langMap
                    ?.BUTTON_UPDATE_PROFILE_SEND_VERIFICATION_CODE
                }}
              </button>
              <div
                class="d-flex justify-content-between full-width"
                *ngIf="resendOtp"
              >
                <button
                  mat-raised-button
                  class="primary-button uppercase full-width mr-1"
                  (click)="verifyCode()"
                  [disabled]="checkOtpLength() || otpVerified"
                >
                  {{
                    multilingualService.langMap
                      ?.BUTTON_UPDATE_PROFILE_VERIFY_CODE
                  }}
                </button>
                <button
                  mat-raised-button
                  class="primary-button uppercase full-width send-code"
                  (click)="sendVerificationCode(false)"
                  [disabled]="!resendOtp"
                >
                  {{
                    multilingualService.langMap
                      ?.BUTTON_UPDATE_PROFILE_SEND_AGAIN
                  }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="form-group mb-2" style="position: relative">
          <label for="contact_input"
            >{{
              multilingualService.langMap
                ?.LABEL_UPDATE_PROFILE_FORM_CONTACT_NUMBER
            }}<span class="text-primary text-w-600"> *</span>
          </label>
          <input 
            readonly="true"
            class="country-code form-control"
            type="text"
            value="+1"
            style="width: 12%;"
          />

          <input
            id="contact_input"
            formControlName="contact"
            type="text"
            class="form-control"
            (keypress)="checkIfSpace($event)"
            maxlength="10"
            style="margin-left: 47px;width: 85%;"
          />

          <span
            role="alert"
            *ngIf="
              this.userForm.get('contact')?.errors?.required &&
              this.userForm.get('contact')?.touched
            "
            class="text-danger"
            >{{
              multilingualService.langMap?.ERROR_MSG_MOBILE_NUMBER_IMP
            }}</span
          >
          <span
            role="alert"
            *ngIf="
              (this.userForm.get('contact')?.errors?.minlength ||
                this.userForm.get('contact')?.errors?.maxlength) &&
              this.userForm.get('contact')?.touched
            "
            class="text-danger"
            >{{
              multilingualService.langMap
                ?.ERROR_MSG_MOBILE_NUMBER_VALIDATION_DIGITS
            }}</span
          >
        </div>
        <div class="form-group mb-2">
          <label for="firstName_value">{{
            multilingualService.langMap?.LABEL_REGISTRATION_FORM_FIRST_NAME
          }}</label>
          <p id="firstName_value" class="text-w-700">
            {{ this.userForm.get("firstName")?.value }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="lastName_value">{{
            multilingualService.langMap?.LABEL_REGISTRATION_FORM_LAST_NAME
          }}</label>
          <p id="lastName_value" class="text-w-700">
            {{ this.userForm.get("lastName")?.value }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="DOB_value"
            >{{
              multilingualService.langMap?.LABEL_MEMBERSHIP_DETAILS_DOB
            }}
            (MM-DD-YYYY)</label
          >
          <p id="DOB_value" class="text-w-700">
            {{ this.userForm.get("dob")?.value | date : "MM-dd-yyy" }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="card_id_value">{{
            multilingualService.langMap?.LABEL_COMMON_CARD_ID
          }}</label>
          <p id="card_id_value" class="text-w-700">
            {{ this.userForm.get("cardId")?.value }}
          </p>
        </div>
        <div class="form-group mb-2">
          <label for="rx_grp_value">{{
            multilingualService.langMap?.LABEL_UPDATE_PROFILE_FORM_RXGRP
          }}</label>
          <p id="rx_grp_value" class="text-w-700">
            {{ this.userForm.get("rxGrp")?.value }}
          </p>
        </div>
      </form>
    </div>
    <div class="empty-box-height auto-margin flex-column" *ngIf="showError">
      <img
        aria-hidden="true"
        src="assets/images/wrong.svg"
        alt="Something went wrong"
        width="75px"
      />
      <p role="alert" class="title-11 text-w-700 mt-1">
        {{ multilingualService.langMap?.ERROR_COMMON_SOMETHING_WENT_WRONG }}
      </p>
    </div>
  </mat-dialog-content>
  <div
    class="bottom-btn justify-content-center mat-dialog-actions"
    *ngIf="!showError"
  >
    <!-- <img *ngIf="isLoading" class="loader" src="../../../../assets/images/loader.gif" alt="loader" width="60px" /> -->
    <button
      *ngIf="
        !isLoading &&
        (userEligibilityStatus === 'ELIGIBILE' ||
          userEligibilityStatus === 'ELIGIBLE' ||
          userEligibilityStatus === 'FUTURE_EFFECTIVE')
      "
      [disabled]="userForm.invalid || !otpVerified"
      (click)="update()"
      mat-raised-button
      class="primary-button uppercase"
    >
      {{ multilingualService.langMap?.LABEL_DRUG_PRICING_MODAL_SUBMIT }}
    </button>
    <button
      *ngIf="isLoading"
      mat-raised-button
      class="primary-button uppercase button-loader"
    >
      <span>
        <img src="assets/images/small-loader.gif" alt="loader" width="25px"
      /></span>
    </button>
  </div>
</ng-container>

<div
  aria-busy="true"
  role="status"
  class="center loader-circle"
  *ngIf="!loaded"
>
  <img src="assets/images/loader.gif" alt="loader" width="60px" />
</div>

<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
<ng-template #success>
  <div class="toaster-bg success d-flex justify-content-center">
    <mat-icon class="icon-success mr-1"></mat-icon>
    <span>{{ successMsg }}</span>
  </div>
</ng-template>
